import createReactComponent from '../createReactComponent';
export default createReactComponent('letter-i-small', 'IconLetterISmall', [
  ['path', { d: 'M12 8v8', key: 'svg-0' }],
]);
